"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entitlementReducer = exports.fetchEntitlementSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const entitlementAction_1 = require("./entitlementAction");
const initialState = {
    loading: false,
    error: false,
    data: []
};
exports.fetchEntitlementSlice = (0, toolkit_1.createSlice)({
    name: 'entitlement/fetch',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(entitlementAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.error = false;
            state.data = [];
        })
            .addCase(entitlementAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = false;
            state.data = action.payload;
        })
            .addCase(entitlementAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.data = [];
        });
    }
});
exports.entitlementReducer = exports.fetchEntitlementSlice.reducer;
